export default __webpack_public_path__ + "static/Ray.FortinBoardOfDirectorsTreasurer_social-b15e5b7786f012d83baec2ca92d66d7c.jpg";